function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import Cookies from "js-cookie";
import { broadcastToDocument } from "./events";
// Perform cookie operations
var handleCookies = function(param) {
    var _param_set = param.set, set = _param_set === void 0 ? [] : _param_set, _param_remove = param.remove, remove = _param_remove === void 0 ? [] : _param_remove, _param_get = param.get, get = _param_get === void 0 ? [] : _param_get;
    set.forEach(function(param) {
        var name = param.name, value = param.value, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
        var preventOverwrite = options.preventOverwrite;
        // Provides ability to create `sticky` cookies that will only set once, when the cookie does not exist
        if (preventOverwrite && Cookies.get(name) !== undefined) {
            return;
        }
        Cookies.set(name, value, options);
        broadcastToDocument("" + name + "Set");
    });
    remove.forEach(function(param) {
        var name = param.name, options = param.options;
        return Cookies.remove(name, options);
    });
    return get.reduce(function(previous, name) {
        return _extends({}, previous, _define_property({}, name, Cookies.get(name)));
    }, {});
};
export { handleCookies };

//# sourceMappingURL=cookies.js.map